import { render, staticRenderFns } from "./CellRendererPromotion.vue?vue&type=template&id=c85f3c36&"
import script from "./CellRendererPromotion.vue?vue&type=script&lang=js&"
export * from "./CellRendererPromotion.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererPromotion.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports